module.exports = __webpack_public_path__ + "static/media/cont-mailb2487da4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/cont-mail.svg
// module id = 1225
// module chunks = 0